import { Link } from "react-router-dom";
import DocNavigation from "../../components/DocNavigation";

export default function Installation() {
    return (
        <section className="space-y-10">

            {/* HEADER */}
            <section className="bg-white rounded-xl border border-slate-200 p-10">
                <h1 className="text-2xl font-bold mb-2">Installation</h1>
                <p className="text-slate-600">
                    This section provides a complete, production-ready guide to installing
                    EventFlow on a live server. Each step is explained clearly to avoid
                    common hosting and deployment mistakes.
                </p>
            </section>

            {/* STRATEGY */}
            <section className="bg-white border-l border-[#C9A24E] p-8 rounded-lg">
                <h2 className="text-lg font-semibold mb-3">Deployment Strategy</h2>
                <p className="text-slate-600 text-sm">
                    EventFlow uses a secure Laravel deployment approach where the application
                    logic is stored outside the web root and only the public assets are
                    accessible via the browser.
                </p>
            </section>

            {/* SERVER REQUIREMENTS */}
            <section className="bg-slate-50 rounded-xl p-8">
                <h3 className="font-semibold mb-3">Server Requirements</h3>
                <ul className="list-disc pl-5 space-y-1 text-slate-600">
                    <li>PHP 8.0 or higher</li>
                    <li>MySQL / MariaDB</li>
                    <li>Apache with <code className="bg-slate-200 px-2 py-1 rounded">mod_rewrite</code> enabled</li>
                    <li>Required PHP extensions installed</li>
                </ul>
            </section>

            {/* UPLOAD FILES */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-3">Step 1: Upload Laravel Project Files</h3>
                <p className="text-slate-600 mb-2">
                    Upload the complete Laravel project into a directory outside
                    <code className="mx-1 bg-slate-200 px-2 py-1 rounded">public_html</code>.
                </p>
                <p className="text-slate-600 text-sm">
                    Example directory:
                    <code className="ml-2 bg-slate-200 px-2 py-1 rounded">
                        /home/username/laravel_project
                    </code>
                </p>
            </section>

            {/* PUBLIC FOLDER */}
            <section className="bg-slate-50 rounded-xl p-8">
                <h3 className="font-semibold mb-3">Step 2: Configure Public Folder</h3>
                <p className="text-slate-600">
                    Move all contents of Laravel’s <code className="bg-slate-200 px-2 py-1 rounded">public</code>
                    folder into <code className="bg-slate-200 px-2 py-1 rounded">public_html</code>.
                    This includes <strong>index.php</strong>, assets, and the <strong>.htaccess</strong> file.
                </p>
            </section>

            {/* INDEX.PHP */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-3">Step 3: Update index.php Paths</h3>
                <p className="text-slate-600">
                    Edit <code className="bg-slate-200 px-2 py-1 rounded">public_html/index.php</code>
                    and update the paths to point to your Laravel project folder.
                </p>
            </section>

            {/* ENV */}
            <section className="bg-slate-50 rounded-xl p-8">
                <h3 className="font-semibold mb-3">Step 4: Configure Environment File</h3>
                <p className="text-slate-600">
                    Update the <code className="bg-slate-200 px-2 py-1 rounded">.env</code> file
                    with correct database credentials, application URL, and production settings.
                </p>
            </section>

            {/* DB */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-3">Step 5: Database Setup</h3>
                <p className="text-slate-600">
                    Create a database, assign a user with full privileges, and import the
                    provided SQL file using phpMyAdmin.
                </p>
            </section>

            {/* FINAL */}
            <section className="bg-slate-50 rounded-xl p-8">
                <h3 className="font-semibold mb-3">Step 6: Final Verification</h3>
                <p className="text-slate-600">
                    Open your domain in the browser and verify that EventFlow loads correctly.
                    If an error occurs, check logs inside
                    <code className="mx-1 bg-slate-200 px-2 py-1 rounded">storage/logs</code>.
                </p>
            </section>

            {/* NEXT */}
            {/* <section className="border-t pt-8 mt-12">
                <p className="text-slate-600">
                    Next, continue with{" "}
                    <Link to="/docs/initial-setup" className="font-medium text-[#C9A24E]">
                        Initial Setup
                    </Link>.
                </p>
            </section> */}
       <DocNavigation
                            previous={{
                                title: "Quick Start",
                                link: "/docs/quick-start"
                            }}
                            next={{
                                title: "Initial Setup",
                                link: "/docs/initial-setup"
                            }}
                        />
        </section>
    );
}
